// @ts-nocheck
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { imageConfig } from "../../../../config/config";
import { getText } from "../../../../utils/util";
import { ArrowDown } from "lucide-react";

export default function TopText({ setIsShowCoin, nowTab, coinListData }) {
  const navigate = useNavigate();
  const [num, setNum] = useState(1);
  const { t: translate } = useTranslation();
  
  const priceChange = coinListData[nowTab]?.close - coinListData[nowTab]?.open;
  const percentChange = coinListData[nowTab]?.close 
    ? ((priceChange / coinListData[nowTab]?.open) * 100).toFixed(2)
    : "0.00";
  
  const isPositive = priceChange > 0;
  
  return (
    <div className="p-4">
      <div className="flex justify-between items-center">
        <div 
          className="flex items-center gap-1 cursor-pointer text-white font-medium"
          onClick={() => {
            setIsShowCoin(true);
          }}
        >
          <span className="text-lg">{nowTab?.toUpperCase()}/USDT</span>
          <ArrowDown size={16} className="ml-1" />
        </div>
        <div className="flex items-center gap-2">
          <span className={`${isPositive ? 'text-green-500' : 'text-red-500'} font-medium`}>
            {priceChange?.toFixed(2)}
          </span>
          <span className={`rounded px-2 py-1 text-sm font-medium ${isPositive ? 'bg-green-500/20 text-green-500' : 'bg-red-500/20 text-red-500'}`}>
            {isPositive ? '+' : ''}{percentChange}%
          </span>
        </div>
      </div>
      <div className="text-2xl font-bold mt-2 text-white">
        {coinListData[nowTab]?.close || '0.00'}
      </div>
    </div>
  );
}
